// Centralized App Configuration
// Edit these values to customize your VeyChat instance

const ENV_API_URL = (process.env.REACT_APP_API_URL || '').trim();

const RUNTIME_ORIGIN =
  typeof window !== 'undefined' && window.location ? window.location.origin : '';

const IS_LOCAL_RUNTIME =
  typeof window !== 'undefined' &&
  window.location &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const RESOLVED_API_BASE_URL =
  ENV_API_URL || (!IS_LOCAL_RUNTIME && RUNTIME_ORIGIN ? RUNTIME_ORIGIN : 'http://localhost:10000');

export const APP_CONFIG = {
  // App Branding
  APP_NAME: 'VeyChat',
  APP_SUBTITLE: 'Multi-Agent Command Interface',
  
  // Logo Configuration
  // Option 1: Use a single letter (set LOGO_IMAGE to null)
  LOGO_LETTER: 'V',
  
  // Option 2: Use an image file (place in public/ folder)
  // Set to the filename (e.g., 'logo.png') or null to use LOGO_LETTER
  // Supported formats: .png, .jpg, .svg
  LOGO_IMAGE: null,  // e.g., 'logo.png' or '/images/logo.svg'
  
  
  // Theme Colors (optional - can override CSS variables)
  // Leave null to use default theme from global.css
  THEME: {
    // Primary accent color (blue-gray by default)
    accentPrimary: null,    // e.g., '#4a6fa5'
    accentSecondary: null,  // e.g., '#5a7fb5'
    accentTertiary: null,   // e.g., '#6a8fc5'
    
    // Background colors
    bgPrimary: null,        // e.g., '#0f1419'
    bgSecondary: null,      // e.g., '#1a1f2e'
    bgTertiary: null,       // e.g., '#242936'
    
    // Text colors
    textPrimary: null,      // e.g., '#e8eaed'
    textSecondary: null,    // e.g., '#b4b8c1'
  },
  
  // Network Configuration
  NETWORK: {
    // For mobile access on same WiFi
    // Set to your computer's local IP address
    // Find it using: ipconfig (Windows) or ifconfig (Mac/Linux)
    HOST: 'localhost',      // e.g., '192.168.1.100'
    PORT: 3000,
  },

  // FastAPI backend:
  // 1) Use REACT_APP_API_URL when provided at build time.
  // 2) Otherwise, in production deployments use same-origin.
  // 3) Local development falls back to localhost:10000.
  API_BASE_URL: RESOLVED_API_BASE_URL,
  
  // Default Agent Avatars
  // These emojis are used for new agents based on their type/role
  // Change these to customize default agent appearances
  DEFAULT_AVATARS: {
    HR: '👤',           // Human Resources agents
    MARKETING: '📊',    // Marketing agents
    DEVELOPER: '💻',    // Development agents
    SUPPORT: '💬',      // Customer support agents
    SALES: '💼',        // Sales agents
    DESIGN: '🎨',       // Design agents
    FINANCE: '💰',      // Finance agents
    OPERATIONS: '⚙️',   // Operations agents
    GENERIC: '🤖',      // Default for new agents
  },
};

export default APP_CONFIG;